// extracted by mini-css-extract-plugin
module.exports = {"questionWrapper":"FaqPart_questionWrapper__W3xaJ","answer":"FaqPart_answer__WuPIj"};